import { action, makeObservable, observable, reaction } from 'mobx';
import { applicationStore } from './applicationStore';

class ConnectionPopupStore {
  isOpenPopup = false;

  popupName = '';

  constructor() {
    makeObservable(this, {
      popupName: observable,
      isOpenPopup: observable,
      open: action.bound,
      close: action.bound,
      setPopupName: action.bound,
      setIsOpenPopup: action.bound,
    });

    reaction(
      () => this.isOpenPopup,
      (value) => {
        applicationStore.setIsShowBlackLayer(value);
      }
    );
  }

  setIsOpenPopup(bool) {
    this.isOpenPopup = bool;
  }

  setPopupName(name) {
    this.popupName = name;
  }

  open(name) {
    this.setIsOpenPopup(true);
    this.setPopupName(name);
  }

  close = () => {
    this.isOpenPopup = false;
    this.popupName = '';
  };
}

export const connectionPopupStore = new ConnectionPopupStore();
